import React from 'react';
import {Trans} from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {API_ROOT, APP_URL} from '../../../../../../utils';
import Icon from '../../../../../../components/icon';
import ChoosePlan from '../choose-plan';
import {connect} from 'react-redux';

const InvalidLabelAttachmentPopup = (props) => {

    function windowCloseIfGmailAddOnPopup(){
        if(props.checkGAddon ==='gmailaddon'){
            window.close();
        }
    }
    const { t } = useTranslation();

	switch (props.error) {
		case 'CONTACT_GROUP_250PLUS':
            return (
                <div className="p-4">
                    <h2><Icon name="level-up" className="text-danger"/> <span className="text-danger">{t("textUpgradeTitle")}</span></h2>
                    <p>{t("textCONTACTGROUP250PLUS")}</p>
                    <hr/>
                    <h3>{t("textUpgradeContent8")}</h3>
                    <p><Trans i18nKey="textUpgradeContent9" values={{plan_name:"Enterprise"}}/></p>
                    <div className="text-right">
                        <a role="button" className="btn btn-default text-white" href={`${API_ROOT}/api/payment/upgrade`} target="_blank" rel="noreferrer">{t("textUpgradeNow")}!</a>
                    </div>
                </div>
            );
        case 'INVALID_STATUS_FOR_ATTACHMENT':
            if(props.profile.domain.status === "FREE" && props.profile.domain.plan === "INVITED"){
                return (
                    <ChoosePlan />
                );
            } else {
                return (
                    <div className="p-4">
                        <h2><Icon name="level-up" className="text-danger"/> <span className="text-danger">{t("textUpgradeTitle")}</span></h2>
                        <p>{t("textAttachmentPermission")}</p>
                        <hr/>
                        <h3>{t("textUpgradeContent8")}</h3>
                        <p><Trans i18nKey="textUpgradeContent9" values={{plan_name:"Enterprise"}}/></p>
                        <div className="text-right">
                            <a role="button" className="btn btn-default text-white" href={`${API_ROOT}/api/payment/upgrade`} onClick ={windowCloseIfGmailAddOnPopup} target="_blank" rel="noreferrer">{t("textUpgradeNow")}!</a>
                        </div>
                    </div>
                );
            }
		default:
			return (
				<div className="p-4">
					<h2>{t("textUnkownError")}</h2>
					<p><Trans i18nKey="textInvalidStatusForAttachment" components={{a: <a href={`${APP_URL}/support`}> </a>}} /></p>
				</div>
			);
	}

};

const mapStateToProps = (state) => {
	return {
        profile: state.profileReducer.getProfile,
	    checkGAddon: state.profileReducer.setGmailAddOnData.checkGmailAddon,
	};
};
export default connect(mapStateToProps, null)(InvalidLabelAttachmentPopup);
